export default "__VITE_ASSET__B3Vj8qrU__"